import { createSelector } from "reselect";

export const makeSelectCurrentUsers = createSelector(
  (state) => state.currentUserReducer,
  (currentUser) => currentUser.isLoading
);
